import { sectionRenderer } from '@theme/section-renderer';

if (!customElements.get('linked-products-picker')) {
  customElements.define(
    'linked-products-picker',
    class LinkedProductsPicker extends HTMLElement {
      #abortController = null;

      connectedCallback() {
        this.#abortController = new AbortController();
        const { signal } = this.#abortController;

        this.addEventListener('click', (e) => this.#handleClick(e), { signal });
        this.addEventListener('mouseover', (e) => this.#handleHover(e), { signal });
      }

      disconnectedCallback() {
        this.#abortController?.abort();
      }

      #handleHover(event) {
        const swatch = event.target.closest('.lpp__swatch[data-product-handle]');
        if (!swatch) return;

        const handle = swatch.dataset.productHandle;
        const sectionId = this.dataset.sectionId;
        const productUrl = new URL(`/products/${handle}`, window.location.origin);

        // Warm the cache so the click feels instant
        sectionRenderer.getSectionHTML(sectionId, false, productUrl);
      }

      async #handleClick(event) {
        const swatch = event.target.closest('.lpp__swatch[data-product-handle]');
        if (!swatch) return;
        if (swatch.getAttribute('aria-pressed') === 'true') return;

        const handle = swatch.dataset.productHandle;
        const sectionId = this.dataset.sectionId;

        this.setAttribute('loading', '');

        try {
          const productUrl = new URL(`/products/${handle}`, window.location.origin);
          await sectionRenderer.renderSection(sectionId, { url: productUrl, cache: false });
          history.pushState(null, '', `/products/${handle}`);
          this.#reinitGallery(sectionId);
        } catch {
          window.location.href = `/products/${handle}`;
        } finally {
          this.removeAttribute('loading');
        }
      }

      #reinitGallery(sectionId) {
        const sectionEl = document.getElementById(`shopify-section-${sectionId}`);
        if (!sectionEl) return;

        const slideshows = [...sectionEl.querySelectorAll('slideshow-component')];

        // Morph strips 'in-viewport' but IntersectionObserver won't re-fire
        // because the slideshow never left the viewport. Restore it immediately
        // so the mobile scroller isn't stuck in overflow:hidden.
        for (const slideshow of slideshows) {
          slideshow.setAttribute('in-viewport', '');
        }

        // Force-reconnect zoom dialogs so connectedCallback re-reads refs from
        // the morphed DOM. Morph updates the dialog's children but updatedCallback
        // is never triggered on live elements, leaving refs.media stale.
        for (const zoomDialog of sectionEl.querySelectorAll('zoom-dialog')) {
          const { parentNode, nextSibling } = zoomDialog;
          if (!parentNode) continue;
          parentNode.removeChild(zoomDialog);
          parentNode.insertBefore(zoomDialog, nextSibling);
        }

        // Rescan DOM so GLightbox gallery reflects the new product's images
        /** @type {any} */ (window).__productGLightbox?.reload();

        // Reset slideshow scroll position after refs are updated
        requestAnimationFrame(() => {
          for (const slideshow of slideshows) {
            slideshow.select?.(0, undefined, { animate: false });
          }
        });
      }
    },
  );
}
